module.exports = __webpack_public_path__ + "static/img/HuangMu_larouPic.2ef392fb.png";